export default __webpack_public_path__ + "static/new-relic-6e825e1200f62bcb6a318b88a05acf49.svg";